import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang'

Vue.use(VueI18n)

const getLocale = () => {
    const locale = localStorage.getItem("locale");
    if(locale == null){
        return process.env.VUE_APP_DB_LOCALE_PTBR;
    } 
    
    return locale;
}

const i18n = new VueI18n({
    locale: getLocale(),
    messages
})

export default i18n
